import { AssignmentType } from './steps/select-project/types';
import { Step, StepsId, StrategyOptions } from './types';

export const PLACEHOLDER_ASSIGNMENT_TABS = [
  {
    value: AssignmentType.Pending,
  },
  {
    value: AssignmentType.All,
  },
];

export const PLACEHOLDER_FILTER_CRITERIA_FIELD = {
  fieldName: 'hasFullyAssignedPh',
  customField: false,
  sourceType: 'project',
  type: 'Boolean',
};

export const DEFAULT_STEPS: Step[] = [
  {
    id: StepsId.SelectProject,
    text: 'select_a_project',
  },
  {
    id: StepsId.LoadResources,
    text: 'choose_a_method',
  },
  {
    id: StepsId.PlanTeam,
    text: 'plan_your_team',
  },
];

export const FINANCIAL_STEP: Step = {
  id: StepsId.OptimizeFinancial,
  text: 'optimize_financial',
};

export const ALLOCATE_STEP: Step = {
  id: StepsId.Allocate,
  text: 'allocate',
};

export const STRATEGY_WITH_DETAILED_DESCRIPTION = {
  [StrategyOptions.LoadBalanced]: {
    title: 'load_balance',
    description: 'load_balance_description_detailed',
  },
  [StrategyOptions.MaximumMargin]: {
    title: 'maximum_margin',
    description: 'maximum_margin_description_detailed',
  },
  [StrategyOptions.Manual]: {
    title: 'manual',
    description: 'manual_description_detailed',
  },
};
